import { buildApiUrl, API_ENDPOINTS, apiRequest } from '../config/api.js'

export const timeJustificationsApi = {
  async getTimeJustifications(userId) {
    const url = buildApiUrl(`/time-justifications/${userId}`)
    return apiRequest(url)
  },

  async createTimeJustification(userId, data) {
    const url = buildApiUrl(`/time-justifications/${userId}`)
    return apiRequest(url, {
      method: 'POST',
      body: JSON.stringify(data),
    })
  },

  async updateTimeJustification(id, data) {
    const url = buildApiUrl(`/time-justifications/${id}`)
    return apiRequest(url, {
      method: 'PUT',
      body: JSON.stringify(data),
    })
  },

  async deleteTimeJustification(id) {
    const url = buildApiUrl(`/time-justifications/${id}`)
    return apiRequest(url, {
      method: 'DELETE',
    })
  },

  async approveTimeJustification(id, data) {
    const url = buildApiUrl(`/time-justifications/${id}/approve`)
    return apiRequest(url, {
      method: 'POST',
      body: JSON.stringify(data),
    })
  },

  async rejectTimeJustification(id, data) {
    const url = buildApiUrl(`/time-justifications/${id}/reject`)
    return apiRequest(url, {
      method: 'POST',
      body: JSON.stringify(data),
    })
  },

  async getPendingTimeJustifications(managerId) {
    const url = buildApiUrl(`/time-justifications/pending/${managerId}`)
    return apiRequest(url)
  }
}
